import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEO from "@/components/base/SEO";
import { Link } from "react-router-dom";

export default function AboutPage() {
  const breadcrumbs = [
    { label: "首页", to: "/" },
    { label: "关于我们", to: "/about" },
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.label,
          item: `http://jiarenmei.com/${item.to}`,
        })),
      },
      {
        "@type": "AboutPage",
        name: "关于韩漫画网",
        description: "韩漫画网是专注于高清免费韩国漫画的在线阅读平台，提供最新热门漫画资源。",
        url: "http://jiarenmei.com/about",
        isPartOf: { "@id": "http://jiarenmei.com/#website" },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "韩漫画网上的漫画是免费的吗？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "是的，韩漫画网上的所有漫画都是免费在线阅读的，无需付费即可畅享高清画质漫画。",
            },
          },
          {
            "@type": "Question",
            name: "韩漫画网多久更新一次？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "我们的漫画通常按照原作的更新频率同步更新，大多数热门漫画保持每日或每周更新的节奏。",
            },
          },
          {
            "@type": "Question",
            name: "如何在手机上看漫画？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "韩漫画网支持移动端自适应浏览，直接用手机浏览器访问我们的网站即可获得良好的阅读体验。",
            },
          },
          {
            "@type": "Question",
            name: "漫画画质怎么样？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "我们提供高清画质的漫画内容，确保您获得清晰流畅的阅读体验。所有漫画均经过精心处理，画质清晰不失真。",
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title="关于我们 - 韩漫画网 | 品牌介绍与联系方式"
        description="韩漫画网是专注于高清免费韩国漫画的在线阅读平台。了解我们的品牌故事、核心优势和联系方式，加入数百万漫画爱好者的阅读社区。"
        canonicalUrl="http://jiarenmei.com/about"
        jsonLd={jsonLd}
        type="website"
      />
      <Navbar />
      <main className="pt-16">
        <section className="bg-background-50 py-12 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8">
              {breadcrumbs.map((item, index) => (
                <span key={item.to} className="flex items-center gap-2">
                  {index > 0 && (
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-xs"></i>
                    </div>
                  )}
                  {index === breadcrumbs.length - 1 ? (
                    <span className="text-foreground-900 font-medium">{item.label}</span>
                  ) : (
                    <Link to={item.to} className="hover:text-primary-500 transition-colors">
                      {item.label}
                    </Link>
                  )}
                </span>
              ))}
            </nav>

            <div className="text-center mb-14">
              <p className="text-xs tracking-widest text-primary-500 font-medium mb-3 uppercase">ABOUT US</p>
              <h1 className="text-3xl md:text-5xl font-extrabold text-foreground-900 leading-tight mb-4">
                为每一位漫画爱好者
                <br />
                <span className="font-heading italic text-primary-500">创造最好的阅读体验</span>
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                韩漫画网致力于打造中文世界最优质的韩国漫画阅读平台。我们精选海量优质韩漫资源，以高清画质呈现给每一位读者。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
              <div className="bg-primary-50/50 rounded-2xl p-8 md:p-10 relative overflow-hidden">
                <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 cursor-pointer">
                  <i className="ri-arrow-right-up-line text-lg text-primary-500"></i>
                </div>
                <p className="text-5xl md:text-6xl font-extrabold font-heading text-primary-500 mb-4">2,500+</p>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">精选漫画作品</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  涵盖恋爱、奇幻、动作、悬疑、搞笑、古风等丰富题材，持续更新中。每一部作品都经过精心挑选，确保内容质量。
                </p>
                <p className="text-xs italic text-primary-400 mt-4 font-heading">品质为先，精选佳作</p>
              </div>

              <div className="bg-accent-50/50 rounded-2xl p-8 md:p-10 relative overflow-hidden">
                <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 cursor-pointer">
                  <i className="ri-arrow-right-up-line text-lg text-accent-500"></i>
                </div>
                <p className="text-5xl md:text-6xl font-extrabold font-heading text-accent-500 mb-4">800万+</p>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">活跃用户社区</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  数百万漫画爱好者在这里相聚，分享阅读心得，讨论剧情发展。我们的社区活跃、友好、充满热情。
                </p>
                <p className="text-xs italic text-accent-400 mt-4 font-heading">连接每一个热爱漫画的灵魂</p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
              <div className="flex-1">
                <p className="text-xs tracking-widest text-primary-500 font-medium mb-3 uppercase">OUR MISSION</p>
                <blockquote className="text-2xl md:text-3xl font-heading italic text-foreground-900 leading-relaxed mb-6">
                  "让每一个热爱漫画的人，都能在这里找到属于自己的故事。"
                </blockquote>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-background-200 overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20Korean%20person%20portrait%20in%20black%20and%20white%2C%20head%20and%20shoulders%2C%20clean%20background%2C%20modern%20editorial%20style%2C%20soft%20lighting%2C%20natural%20expression&width=100&height=100&seq=founder-avatar&orientation=squarish"
                      alt="创始人"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">金志勋</p>
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs text-foreground-500">创始人 &amp; CEO</span>
                      <div className="w-3.5 h-3.5 flex items-center justify-center rounded-full bg-accent-500">
                        <i className="ri-check-line text-[8px] text-background-50"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Creative%20team%20working%20together%20in%20modern%20office%2C%20collaborative%20atmosphere%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20casual%20professional%20style%2C%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20photography%2C%20friendly%20vibe%2C%20digital%20content%20creators&width=600&height=400&seq=team-photo-about&orientation=landscape"
                    alt="韩漫画网团队"
                    className="w-full aspect-[3/2] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="flex-1 flex items-center">
                <div className="w-full relative rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cozy%20modern%20workspace%20with%20warm%20lighting%2C%20bookshelf%20and%20plants%2C%20creative%20atmosphere%2C%20coral%20and%20cream%20color%20palette%2C%20minimal%20interior%20design%2C%20clean%20composition%2C%20high%20quality%20editorial%20photography%2C%20inviting%20mood&width=800&height=600&seq=cta-about-contact&orientation=landscape"
                    alt="联系我们"
                    className="w-full aspect-[4/3] object-cover"
                  />
                </div>
              </div>

              <div className="flex-1 flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-4">
                  与我们取得联系
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-8">
                  如果您有任何建议、合作意向或问题反馈，欢迎通过以下方式联系我们。我们的团队会在24小时内回复您。
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p className="text-sm font-medium text-foreground-900">hello@jiarenmei.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">客服电话</p>
                      <p className="text-sm font-medium text-foreground-900">400-888-9999</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-500 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">公司地址</p>
                      <p className="text-sm font-medium text-foreground-900">北京市朝阳区望京SOHO T1-A座 1208室</p>
                    </div>
                  </div>
                </div>

                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer w-fit"
                >
                  返回首页阅读漫画
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 text-center mb-10">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: "韩漫画网上的漫画是免费的吗？", a: "是的，韩漫画网上的所有漫画都是免费在线阅读的，无需注册或付费即可畅享高清画质漫画。我们致力于为漫画爱好者提供优质的免费阅读服务。" },
                { q: "韩漫画网多久更新一次？", a: "我们的漫画通常按照原作的更新频率同步更新，大多数热门漫画保持每日或每周更新的节奏。您可以在首页的「最新更新」区域查看当日更新的作品。" },
                { q: "如何在手机上看漫画？", a: "韩漫画网支持移动端自适应浏览，直接用手机浏览器访问我们的网站即可获得良好的阅读体验。页面会根据您的设备自动调整布局。" },
                { q: "漫画画质怎么样？", a: "我们提供高清画质的漫画内容，确保您获得清晰流畅的阅读体验。所有漫画均经过精心处理和优化，画质清晰不失真，让您的阅读体验更加舒适。" },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-xl overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer">
                    <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}